export const itemsSelect: Record<"value" | "label", string>[] = [
  {
    value: "Рассказали коллеги",
    label: "Рассказали коллеги",
  },
  {
    value: "От родственников / родителей",
    label: "От родственников / родителей",
  },
  {
    value: "От друзей / знакомых",
    label: "От друзей / знакомых",
  },
  {
    value: "Другое",
    label: "Другое",
  },
]

export enum ValidationPoints {
  CORRECT_VALIDATION = 25,
  INCORRECT_VALIDATION = 0,
  FIRST_LETTER = 13,
}

export function calculateResultPercentageGreenBar(formik: any) {
  const FIO = formik.values.fio.data

  const fioScore = !formik.errors.fio
    ? (FIO?.name && FIO.name?.length > 0
        ? ValidationPoints.FIRST_LETTER
        : ValidationPoints.INCORRECT_VALIDATION) +
      (FIO?.surname && FIO.surname?.length > 0
        ? ValidationPoints.FIRST_LETTER
        : ValidationPoints.INCORRECT_VALIDATION)
    : 0

  const phoneScore = !formik.errors.phone
    ? ValidationPoints.CORRECT_VALIDATION
    : ValidationPoints.INCORRECT_VALIDATION

  return fioScore + phoneScore
}
